import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; // eslint-disable-line

import Header, {
  NavLink,
  NavLinks,
  PrimaryLink as PrimaryLinkBase,
  LogoLink,
  NavToggle,
  DesktopNavLinks
} from "../headers/light.js";

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none w-full`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;

const PrimaryLink = tw(PrimaryLinkBase)`rounded-full`

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 h-screen min-h-144 overflow-hidden`}
`;

const BackgroundVideo = styled.video`
  ${tw`absolute inset-0 w-full h-full object-cover`}
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-black opacity-75`;

const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`;

const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`;

const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-snug -mt-24 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const Subtitle = styled.h2`
  ${tw`text-center text-gray-300 mt-4 sm:mt-6 text-lg sm:text-xl lg:text-2xl font-medium`}
`;

const PrimaryAction = tw.button`rounded-full px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 font-bold shadow transition duration-300 bg-orange-600 text-gray-100 hocus:bg-orange-700 hocus:text-gray-200 focus:outline-none focus:shadow-outline`;

export default () => {
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="#main-feature">
        Sobre Nós
      </NavLink>
      <NavLink href="#products-container">
        Produtos
      </NavLink>
      <NavLink href="#contactUs-container">
        Contato
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <PrimaryLink href="https://wa.me/5562985174521?text=Ol%C3%A1%2C%20Gostaria%20de%20comprar%20um%20de%20seus%20produtos!">
        Contate-nos
      </PrimaryLink>
    </NavLinks>
  ];

  
  return (
    <Container>
      <BackgroundVideo
        autoPlay
        loop
        muted
        playsInline
        src="/assets/Video_4.mp4" // substitua pela URL do seu vídeo
      />
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
        <Content>
          <Heading>
            APIÁRIO PORTO
          </Heading>
          <Subtitle> O Melhor mel Silvestre! </Subtitle>
          
          <a href="#main-feature"><PrimaryAction> Quem Somos </PrimaryAction></a>
          
        </Content>
      </HeroContainer>
    </Container>
  );
};
